import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "value": _vm.open,
      "onClose": _vm.close,
      "close": false
    }
  }, [_c('b-row', {
    staticClass: "form-group"
  }, [_c('b-col', {
    staticClass: "busca",
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descrição",
      "label-for": "discriminacao"
    }
  }, [_c(VTextarea, {
    attrs: {
      "full-width": "",
      "no-resize": "",
      "rows": "3",
      "auto-grow": "",
      "maxlength": "600"
    },
    model: {
      value: _vm.valueServico.discriminacao,
      callback: function callback($$v) {
        _vm.$set(_vm.valueServico, "discriminacao", $$v);
      },
      expression: "valueServico.discriminacao"
    }
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "form-group"
  }, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Quantidade",
      "label-for": "quantidade"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "quantidade",
      "name": "quantidade"
    },
    model: {
      value: _vm.valueServico.quantidade,
      callback: function callback($$v) {
        _vm.$set(_vm.valueServico, "quantidade", $$v);
      },
      expression: "valueServico.quantidade"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Valor Unitário",
      "label-for": "unitario"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "unitario",
      "name": "unitario"
    },
    model: {
      value: _vm.valueServico.unitario,
      callback: function callback($$v) {
        _vm.$set(_vm.valueServico, "unitario", $$v);
      },
      expression: "valueServico.unitario"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Total R$",
      "label-for": "total"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "total",
      "name": "total",
      "disabled": ""
    },
    model: {
      value: _vm.totalServico,
      callback: function callback($$v) {
        _vm.totalServico = $$v;
      },
      expression: "totalServico"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1)], 1), _c('div', {
    staticClass: "confirm-buttons"
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v("Fechar")]), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("Gravar")])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };